import { createContext, useContext } from 'react';

export const BatchContext = createContext(null);

export function useBatch() {
    const ctx = useContext(BatchContext);
    if (!ctx) throw new Error('useBatch must be used within a BatchProvider');
    return ctx;
}